import constants from '../constants';

export const isPdfFile = (candidate) => {
  if (!candidate) return false;

  return (
    candidate.type?.toLowerCase() === constants.pdfFileType ||
    candidate.name?.toLowerCase().endsWith('.pdf') === true
  );
};
